import React, { useEffect, useState } from "react";
import "./styles.scss";
import EntitySelectionCard from "./entity-type-card";
import EntityAuthCard from "./entity-auth-card";
import { connect } from "react-redux";
import { alertActions, commonActions } from "../../_actions";
import { invoiceCreationService } from "../../_services/invoiceCreation.service";
import { appConstants } from "../../_constants";
import { store } from "react-notifications-component";

const FaanCreateInvoice = (props) => {
  const [entityType, setEntityType] = useState(null);
  const [isAgencyIdReady, setIsAgencyIdReady] = useState(false);
  const [isFetchingServices, setIsFetchingServices] = useState(true);
  const { agencyId, dispatch } = props;
  const [organisationList, setOrganisationList] = useState([]);
  const agencyDomain = window.location.origin;
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  let previouslySelectedOrganization = null;

  useEffect(() => {
    const payload = {
      domainURL: agencyDomain,
      agencyId: "",
      agencyCode: "",
    };
    dispatch(commonActions.getBranding(payload));
  }, [agencyDomain, dispatch]);

  useEffect(() => {
    if (agencyId && !isAgencyIdReady) {
      setIsAgencyIdReady(true);
      fetchOrganizationCustomers();
    }
  }, [agencyId, isAgencyIdReady]);

  const fetchOrganizationCustomers = () => {
    let payload = { agencyId: agencyId };
    // TODO: Remove let payload = { agencyId: 10 };
    dispatch(alertActions.startRequest());
    invoiceCreationService.getConsumersOpen(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        setOrganisationList(response?.data || []);
        setIsFetchingServices(false);
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        store.addNotification({
          title: "Error",
          message: res.response || "An error occurred please try again later",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });
      }
    });
  };

  // Handle back button for organization from the invoice initiation page
  useEffect(() => {
    const selectedEntityType = sessionStorage.getItem("entityType");
    const selectedOrganization = sessionStorage.getItem("selectedOrganization");
    if (selectedEntityType === "organization" && selectedOrganization) {
      setEntityType("organization");
      setSelectedOrganization(JSON.parse(selectedOrganization));
    }
  }, []);


  return (
    <div className="faan-payment-container">
      {!entityType ? (
        <EntitySelectionCard setEntityType={setEntityType} />
      ) : (
        <EntityAuthCard
          entityType={entityType}
          setEntityType={setEntityType}
          organisationList={organisationList}
          isFetchingServices={isFetchingServices}
          selectedOrganization={selectedOrganization}
          setSelectedOrganization={setSelectedOrganization}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(FaanCreateInvoice);
